(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function initCartStickyCheckout() {
    const bar = document.querySelector('[data-cart-sticky-checkout]');
    if (!bar) return;

    const mainCheckout = bar.closest('form')?.querySelector('.cart-recap > button[name="checkout"]');
    if (!mainCheckout) return;

    const total = bar.querySelector('.cart-sticky-checkout__total');
    const mobile = window.matchMedia('(max-width: 699px)');
    let mainCheckoutVisible = true;
    let hasItems = true;

    const render = () => {
      const active = mobile.matches && hasItems && !mainCheckoutVisible;
      bar.hidden = !active;
      document.body.classList.toggle('cart-sticky-checkout-active', active);
    };

    new IntersectionObserver(([entry]) => {
      mainCheckoutVisible = entry.isIntersecting;
      render();
    }).observe(mainCheckout);

    new ResizeObserver(() => {
      if (!bar.hidden) {
        document.body.style.setProperty('--cart-sticky-checkout-height', bar.getBoundingClientRect().height + 'px');
      }
    }).observe(bar);

    const updateFromCart = (cart) => {
      if (!cart) return;
      hasItems = cart.item_count > 0;
      if (hasItems) {
        const currency = window.Shopify?.currency?.active;
        if (currency) {
          total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
            currencyDisplay: 'code'
          }).format(cart.total_price / 100);
        }
      }
      render();
    };

    document.addEventListener('cart:change', (event) => updateFromCart(event.detail?.cart));
    document.addEventListener('cart:refresh', async () => {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      if (response.ok) updateFromCart(await response.json());
    });
    mobile.addEventListener('change', render);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartStickyCheckout, { once: true });
  } else {
    initCartStickyCheckout();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["share-your-creation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(root) {
      if (root.dataset.shareReady === 'true') return;
      root.dataset.shareReady = 'true';
      const form = root.querySelector('[data-share-form]');
      const input = root.querySelector('[data-share-input]');
      const results = root.querySelector('[data-share-results]');
      const status = root.querySelector('[data-share-status]');
      let timer;
      let controller;

      function announce(message) {
        status.textContent = message;
        status.hidden = !message;
      }

      function clearResults() {
        results.replaceChildren();
      }

      function renderProducts(products) {
        clearResults();
        for (const product of products) {
          if (!product || !product.url) continue;
          let candidate;
          try {
            candidate = new URL(product.url, window.location.origin);
          } catch (error) {
            continue;
          }
          if (candidate.origin !== window.location.origin || !candidate.pathname.includes('/products/')) continue;
          candidate.hash = 'wiserreviewform';

          const item = document.createElement('li');
          const link = document.createElement('a');
          const title = document.createElement('span');
          const cta = document.createElement('span');
          link.className = 'share-creation__product-link';
          link.href = candidate.pathname + candidate.search + candidate.hash;
          title.className = 'share-creation__product-title';
          title.textContent = product.title;
          cta.className = 'share-creation__product-cta';
          cta.textContent = root.dataset.selectLabel + ' →';

          const featured = product.featured_image || product.image;
          const source = typeof featured === 'string' ? featured : featured && featured.url;
          if (source) {
            const image = document.createElement('img');
            image.className = 'share-creation__product-image';
            image.src = source;
            image.alt = '';
            image.width = 62;
            image.height = 62;
            image.loading = 'lazy';
            link.appendChild(image);
          } else {
            const fallback = document.createElement('span');
            fallback.className = 'share-creation__product-image-fallback';
            fallback.setAttribute('aria-hidden', 'true');
            fallback.textContent = '✦';
            link.appendChild(fallback);
          }

          link.append(title, cta);
          item.appendChild(link);
          results.appendChild(item);
        }
        announce(results.childElementCount ? root.dataset.resultsReady : root.dataset.noResults);
      }

      async function search() {
        const term = input.value.trim();
        if (controller) controller.abort();
        if (term.length < 2) {
          clearResults();
          announce('');
          return;
        }

        controller = new AbortController();
        const path = root.dataset.predictiveRoute.replace(/\/$/, '');
        const endpoint = new URL(path.endsWith('.json') ? path : path + '.json', window.location.origin);
        endpoint.searchParams.set('q', term);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '10');
        endpoint.searchParams.set('resources[options][unavailable_products]', 'show');

        clearResults();
        announce(root.dataset.loading);
        try {
          const response = await fetch(endpoint, { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Search unavailable');
          const payload = await response.json();
          const products = payload.resources && payload.resources.results && payload.resources.results.products;
          renderProducts(Array.isArray(products) ? products : []);
        } catch (error) {
          if (error.name === 'AbortError') return;
          clearResults();
          announce(root.dataset.searchError);
        }
      }

      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(search, 280);
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        window.clearTimeout(timer);
        search();
      });
    }

    function initializeAll(scope) {
      for (const root of scope.querySelectorAll('[data-share-creation]')) initialize(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
